// Post-login redirects. The `redirect` param can be an in-app path (e.g.
// /booking?venue=...) OR a full URL back to the marketing website (e.g. the
// Meeting Room landing page resuming a half-finished booking). Full URLs are
// only honoured for our own hosts, so /login?redirect=https://evil.example can
// never be used to launder a redirect through this domain.
const ALLOWED_EXTERNAL_HOSTS = [
  'clayworks.space',
  'www.clayworks.space',
  'app.clayworks.space',
  'book.clayworks.space',
];

const STAFF_DASHBOARD_PREFIXES = ['/admin', '/manager', '/founders', '/sales', '/finance', '/approvals', '/finance-approvals', '/landlord'];

const isStaffDashboardPath = (path) => {
  const pathname = path.split(/[?#]/)[0];
  return STAFF_DASHBOARD_PREFIXES.some((p) => pathname === p || pathname.startsWith(`${p}/`));
};

// Returns { external: true, url } for an allowed absolute URL on another host,
// { external: false, path } for a safe in-app path, or null if unusable.
export function resolveRedirect(raw) {
  if (!raw) return null;
  if (/^https?:\/\//i.test(raw)) {
    try {
      const url = new URL(raw);
      const isHttps = url.protocol === 'https:';
      const isLocal = url.hostname === 'localhost';
      if (!(isHttps || isLocal)) return null;
      if (url.hostname === window.location.hostname) {
        const path = `${url.pathname}${url.search}${url.hash}`;
        return isStaffDashboardPath(path) ? null : { external: false, path };
      }
      if (ALLOWED_EXTERNAL_HOSTS.includes(url.hostname) || isLocal) {
        return { external: true, url: url.toString() };
      }
    } catch {
      return null;
    }
    return null;
  }
  // In-app path: must be a single-slash path ("//host" is protocol-relative).
  if (!raw.startsWith('/') || raw.startsWith('//')) return null;
  return isStaffDashboardPath(raw) ? null : { external: false, path: raw };
}

// Navigate to a resolved redirect, or fall back to `fallback` (an in-app path).
export function goToRedirect(navigate, raw, fallback = '/dashboard') {
  const target = resolveRedirect(raw);
  if (target?.external) {
    window.location.assign(target.url);
  } else {
    navigate(target?.path || fallback);
  }
}
